/** Юридические документы живут на лендинге — одна редакция для сайта, вебаппа и мобилки. */
const LANDING_URL = 'https://etap-app.ru';

export const LEGAL_URLS = {
  privacy: `${LANDING_URL}/privacy`,
  terms: `${LANDING_URL}/terms`,
  consent: `${LANDING_URL}/consent`,
  cookies: `${LANDING_URL}/privacy#cookies`,
} as const;
